module.exports = __webpack_public_path__ + "41294543041ccb4fc1a77834a6905a63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/empty_results.svg
// module id = 69
// module chunks = 0